export interface IMemberInsightsListKeyParams {
  page: number
  pageSize: number
  search: string
  category: string
}

export const memberInsightsKeys = {
  all: ['member-insights'] as const,
  list: (params: IMemberInsightsListKeyParams) =>
    [...memberInsightsKeys.all, 'list', params] as const,
  producers: () => [...memberInsightsKeys.all, 'producers'] as const,
  categories: () => [...memberInsightsKeys.all, 'categories'] as const,
  download: (downloadUrl: string) =>
    [...memberInsightsKeys.all, 'download', downloadUrl] as const,
} as const
